export function CoverReportLink({ href }: { href: string }) {
  return (
    <a
      className="ph-actionlink"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open cover report (opens in new tab)"
      title="Cover report"
    >
      <svg
        className="ph-actionlink-icon"
        viewBox="0 0 16 16"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M3.25 1.75h6L12.75 5.25v8.5a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V2.5a.75.75 0 0 1 .75-.75Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M9 1.75v3.75h3.75"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 8.5h5M5.5 11h5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </svg>
      <span className="ph-actionlink-l">Report</span>
    </a>
  );
}
